import {
  TreemapModule,
  createTreemapServices
} from "./chunk-R7FJI6CG.mjs";
import "./chunk-KEIR6QF5.mjs";
export {
  TreemapModule,
  createTreemapServices
};
